import * as React from "react";

import { cn } from "@/lib/utils";

type InputProps = React.ComponentProps<"input">;

// What the phone keyboard should offer when a field doesn't say (Felipe, Oct 20:
// "if we need numbers it shows numbers, just text text"). Our own fields don't
// ask for saved passwords, cards or addresses; email fields get the email
// keyboard and autofill; numbers get the number pad. Whatever a caller passes wins.
export const keyboardDefaults = (type: InputProps["type"]): Partial<InputProps> => {
  switch (type) {
    case "email":
      return { autoComplete: "email", autoCapitalize: "none", spellCheck: false };
    case "password":
      return { autoComplete: "current-password" };
    case "tel":
      return { autoComplete: "tel" };
    case "number":
      return { inputMode: "decimal", autoComplete: "off" };
    case "search":
      return { autoComplete: "off", enterKeyHint: "search" };
    case "url":
      return { autoComplete: "off", autoCapitalize: "none", spellCheck: false };
    case undefined:
    case "text":
      return { autoComplete: "off" };
    default:
      return {};
  }
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        {...keyboardDefaults(type)}
        className={cn(
          "flex h-10 w-full rounded-md border-[1.5px] border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
